import { Input, InputFooter, InputHeader } from "@amzn/stencil-react-components/input";
import { Select } from "@amzn/stencil-react-components/select";
import React from "react";

export interface SelectOrInputFieldProps {
  label: string;
  testId: string;
  value: string;
  options?: string[];
  useTextInput: boolean;
  disabled?: boolean;
  required?: boolean;
  noOptionsText?: string;
  error?: string;
  onTextChange: (value: string) => void;
  onSelectChange: (value: string) => void;
}

export const SelectOrInputField: React.FC<SelectOrInputFieldProps> = ({
  label,
  testId,
  value,
  options,
  useTextInput,
  disabled,
  required,
  noOptionsText,
  error,
  onTextChange,
  onSelectChange,
}) => {
  const hasError = !!error;

  if (useTextInput) {
    return (
      <>
        <InputHeader labelText={label} htmlFor={testId} required={required} error={hasError} />
        <Input
          id={testId}
          data-testid={testId}
          value={value}
          disabled={disabled}
          error={hasError}
          aria-invalid={hasError}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => onTextChange(e.target.value)}
        />
        {hasError && (
          <InputFooter id={`${testId}-error`} error data-testid={`${testId}-error`}>
            {error}
          </InputFooter>
        )}
      </>
    );
  }

  return (
    <>
      <InputHeader labelText={label} htmlFor={testId} required={required} error={hasError} />
      <Select
        id={testId}
        dataTestId={testId}
        isSearchable
        isMulti={false}
        noOptionsText={noOptionsText}
        options={options ?? []}
        value={value}
        disabled={disabled}
        onChange={(selectedValue) => onSelectChange(selectedValue ?? "")}
      />
      {hasError && (
        <InputFooter id={`${testId}-error`} error data-testid={`${testId}-error`}>
          {error}
        </InputFooter>
      )}
    </>
  );
};
